import Hero from "./Hero";
import "./Services.css";
import ServicesShowcase from "./Serviceshowcase";

export default function Services() {
  return (
    <>
      <Hero />
      <ServicesShowcase />
    </>
  );
}